module.exports = __webpack_public_path__ + "img/labelwidth_select.90ef2090.png";